import React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { routeElement } from './RouteComponent';
import Login from '../containers/Login';
import SignUp from '../containers/SignUp';
import ConsentToPersonalDataProcessing from '../components/ConsentToPersonalDataProcessing';
import SignUpSuccessPage from '../components/SignUpSuccessPage';
import PasswordRestore from '../containers/PasswordRestore';
import RestoreSuccessPage from '../components/RestoreSuccessPage';
import ChangePasswordAfterRestorePage from '../containers/ChangePasswordAfterRestorePage';
import AllVacanciesPage from '../containers/AllVacanciesPage';
import VacancyPage from '../containers/VacancyPage';


const PublicRoutes = () => (
  <div className="container-fluid p-0">
    <Routes>
      <Route
        path="/all-vacancies"
        element={routeElement(AllVacanciesPage)}
      />
      <Route
        path="/all-vacancies/:id"
        element={routeElement(VacancyPage)}
      />
      <Route
        path="/login"
        element={routeElement(Login)}
      />
      <Route
        path="/signup"
        element={routeElement(SignUp)}
      />
      <Route
        path="/signup/success"
        element={routeElement(SignUpSuccessPage)}
      />
      <Route
        path="/contest-to-personal-data-processing"
        element={routeElement(ConsentToPersonalDataProcessing)}
      />
      <Route
        path="/restore"
        element={routeElement(PasswordRestore)}
      />
      <Route
        path="/restore/success"
        element={routeElement(RestoreSuccessPage)}
      />
      <Route
        path="/password/reset/:uid/:token"
        element={routeElement(ChangePasswordAfterRestorePage)}
      />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  </div>
);

export default PublicRoutes;
